import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login-form"
};
const _hoisted_2 = {
  class: "login-box"
};
const _hoisted_3 = {
  class: "login-input"
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "gap": "10px"
  }
};
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import { encrypt, setToken, treeDataTranslate } from '@/common/utils/index';
import { useLoginStore, useLayoutStore } from '@/store';
import LoginController from '@/api/system/LoginController';

import { ref, reactive, computed } from 'vue';
const __default__ = {
  name: 'Login'
};
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const loginForm = ref();
    const loginStore = useLoginStore();
    const layoutStore = useLayoutStore();
    const router = useRouter();
    const dataForm = reactive({
      mobilePhone: '',
      password: '',
      code: ''
    });
    const countdown = ref(0);
    const isCounting = computed(() => countdown.value > 0);
    const sendVerifyCode = () => {
      if (!dataForm.mobilePhone) {
        ElMessage.warning('请先输入帐号');
        return;
      }
      LoginController.sendVerifyCode({
        loginName: dataForm.mobilePhone
      }).then(() => {
        ElMessage.success('验证码已发送');
        countdown.value = 60;
        const timer = setInterval(() => {
          countdown.value--;
          if (countdown.value <= 0) {
            clearInterval(timer);
          }
        }, 1000);
      }).catch(() => {});
    };
    const dataRule = {
      mobilePhone: [{
        required: true,
        message: '帐号不能为空',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        message: '密码不能为空',
        trigger: 'blur'
      }],
      code: [{
        required: true,
        message: '验证码不能为空',
        trigger: 'blur'
      }]
    };
    const dataFormSubmit = () => {
      loginForm.value?.validate(valid => {
        if (valid) {
          login();
        }
      });
    };
    const login = function (verifyParams = null) {
      let params = {
        loginName: dataForm.mobilePhone,
        password: encrypt(dataForm.password),
        code: dataForm.code,
        captchaVerification: verifyParams?.captchaVerification
      };
      setToken(null);
      LoginController.login(params).then(data => {
        if (data.data.menuList) {
          layoutStore.setMenuList(treeDataTranslate(data.data.menuList, 'menuId', 'parentId'));
          delete data.data.menuList;
        }
        setToken(data.data.tokenData);
        layoutStore.setCurrentMenu(null);
        layoutStore.clearAllTags();
        if (data.data.tokenData) {
          delete data.data.tokenData;
        }
        loginStore.setUserInfo(data.data);
        // 登录成功跳转页面
        let currentWorkbenchId = data.data.currentWorkbenchId;
        if (data.data.currentWorkbenchId == null && Array.isArray(data.data.workbenchIds) && data.data.workbenchIds.length > 0) {
          // 如果没有当前工作台ID，且有多个工作台ID，则默认选择第一个
          currentWorkbenchId = data.data.workbenchIds[0];
          data.data.currentWorkbenchId = currentWorkbenchId;
        }
        if (currentWorkbenchId == null) {
          layoutStore.setCurrentMenuId('');
          router.replace({
            name: 'main'
          });
        } else {
          layoutStore.setCurrentMenuId('WORKBENCH_MENU_ID');
          router.replace({
            name: 'reportRender',
            query: {
              pageId: data.data.currentWorkbenchId
            }
          });
        }
      }).catch(e => {
        console.error(e);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "title"
      }, "合同管理系统", -1)), _cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "desc"
      }, "合同管理系统，一站式合同管理解决方案", -1)), _createVNode(_component_el_form, {
        model: _unref(dataForm),
        rules: dataRule,
        "label-position": "top",
        ref_key: "loginForm",
        ref: loginForm,
        onKeyup: _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "mobilePhone",
            label: "",
            style: {
              "margin-top": "48px",
              "margin-bottom": "25px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).mobilePhone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(dataForm).mobilePhone = $event),
              style: {
                "width": "100%",
                "height": "50px"
              },
              placeholder: "请输入帐号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "password",
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(dataForm).password = $event),
              style: {
                "width": "100%",
                "height": "50px"
              },
              type: "password",
              placeholder: "请输入密码",
              "show-password": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "code",
            label: ""
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).code,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(dataForm).code = $event),
              style: {
                "flex": "1",
                "height": "50px"
              },
              placeholder: "请输入验证码"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              disabled: _unref(isCounting),
              style: {
                "height": "50px",
                "width": "120px"
              },
              onClick: sendVerifyCode
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(isCounting) ? `${_unref(countdown)}秒后重发` : '获取验证码'), 1)]),
              _: 1
            }, 8, ["disabled"])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "login-btn-submit",
          type: "primary",
          size: "large",
          onClick: _cache[3] || (_cache[3] = $event => dataFormSubmit()),
          style: {
            "width": "100%",
            "margin-top": "48px",
            "height": "50px",
            "font-size": "16px"
          }
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 登录 ", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "onKeyup"])])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
        style: {
          "position": "absolute",
          "right": "0",
          "bottom": "0",
          "left": "0",
          "height": "44px",
          "font-size": "14px",
          "color": "#666",
          "background-color": "#f7fafe"
        }
      }, [_createElementVNode("p", {
        style: {
          "text-align": "center",
          "line-height": "44px"
        }
      }, "Copyright © 2025")], -1))]);
    };
  }
});